import PropTypes from 'prop-types';
import React from 'react';

function handleProductSeriesSelect ( obj ) {

    this.handleProductSeriesSelect( obj );

}

const PartGroupPanel = props => (
    <section className="product-series-panel">
        {!props.isSearch && props.productList.length > 0 && props.productList.map( product => (
            <div className="series-link" key={product.productSeriesId}>
                <span onClick={handleProductSeriesSelect.bind( props, product )}>
                    {product.productSeriesName}
                </span>
            </div>
        ) )}
    </section>
);
PartGroupPanel.displayName = 'PartGroupPanel';
PartGroupPanel.propTypes = {
    isSearch: PropTypes.bool.isRequired,
    productList: PropTypes.array.isRequired,
};
export default PartGroupPanel;
